import * as React from "react";
import classnames from "classnames";
const SummaryContainer = ({
  children,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement("article", { className: classnames("summary__container", className), ...rest }, children);
export {
  SummaryContainer as default
};
//# sourceMappingURL=SummaryContainer.js.map
